
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guru-fun",
      function () {
        return require("private-next-pages/guru-fun.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guru-fun"])
      });
    }
  